import React, { FC, Dispatch, SetStateAction } from "react";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import ReusableAccordian from "../../ReusableAccordion";
import SizeLayout from "../../SizeLayout";
import PleaseNote from "../../PleaseNote";
import SliderPocket from "../SliderPocket/SliderPocket";
import { RowLayout, ColLayout } from "../../../util/accordianStyles";
import useWidthSelector from "./useWidthSelector";

interface SliderWidthProps {
  setSliderConfig: Dispatch<SetStateAction<string>>;
}

const SliderWidthAccordian: FC<SliderWidthProps> = ({ setSliderConfig }) => {
  const {
    handleFractionChange,
    handleWidthChange,
    widthErr,
    isPocketing,
    sliderP,
    width,
    fraction,
  } = useWidthSelector(setSliderConfig);

  return (
    <ReusableAccordian
      accordionName="sliderWidth"
      heading={isPocketing ? "Daylight Frame Width" : "Net Frame Width"}
      secondaryHeading="Select a Width"
      colOrRow="col"
      required5={true}
    >
      <PleaseNote notes={`For single-sided pocketing units, we recommend a Net Frame Width 1-1/2" less than the Rough Opening Width, and for double-sided units, 2" less than the Rough Opening Width.`} />

      <ColLayout style={{ width: "100%", justifyContent: "center" }}>
        <RowLayout>
          <Typography style={{ fontWeight: "bold", paddingRight: 60 }}>
            Pocketing:
          </Typography>

          <SliderPocket setSliderConfig={setSliderConfig} />
        </RowLayout>

        {sliderP && (
          <ColLayout style={{ width: "100%" }}>
            <Divider style={{ width: "50%" }} />

            <RowLayout style={{ position: "relative" }}>
              <Typography style={{ fontWeight: "bold", paddingRight: 40 }}>
                {isPocketing ? "Daylight Frame Width:" : "Net Frame Width:"}
              </Typography>

              <SizeLayout
                size={width}
                handleChange={handleWidthChange}
                sizeErr={widthErr}
                name="sliderWidth"
                fractionValue={fraction || ""}
                handleFractionChange={handleFractionChange}
              />
            </RowLayout>
          </ColLayout>
        )}
      </ColLayout>
    </ReusableAccordian>
  );
};

export default SliderWidthAccordian;
